import { createAction, createReducer } from '@reduxjs/toolkit';
import { message } from 'common/services/message';

import api from 'common/api';
import { AppState } from 'common/models/AppState';

import { startListening } from '../../../../root/store/listener-middleware';
import { selectAuth } from '../../ducks';

// Actions
export const requestPasswordRecoveryActions = {
  request: createAction<string>('@@Auth/PasswordRecovery/REQUEST'),
  success: createAction('@@Auth/PasswordRecovery/SUCCESS'),
  failure: createAction('@@Auth/PasswordRecovery/FAILURE'),
};

export const changePasswordActions = {
  request: createAction<{ password: string; token: string }>('@@Auth/ChangePassword/REQUEST'),
  success: createAction('@@Auth/ChangePassword/SUCCESS'),
  failure: createAction('@@Auth/ChangePassword/FAILURE'),
};

export const resetPasswordRecoveryAction = createAction('@@Auth/PASSWORD_RECOVERY_RESET');

// Reducers
export interface ForgottenPasswordState {
  success: boolean;
  error: boolean;
}

const initialState: ForgottenPasswordState = {
  success: false,
  error: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(requestPasswordRecoveryActions.success, (state) => {
      state.success = true;
    })
    .addCase(requestPasswordRecoveryActions.failure, (state) => {
      state.error = true;
    })
    .addCase(resetPasswordRecoveryAction, () => initialState);
});

// Selectors
export function selectAuthForgottenPassword(state: AppState) {
  return selectAuth(state).forgottenPassword;
}

export function selectForgottenPasswordError(state: AppState) {
  return selectAuthForgottenPassword(state).error;
}

export function selectForgottenPasswordSuccess(state: AppState) {
  return selectAuthForgottenPassword(state).success;
}

// Listeners
startListening({
  actionCreator: requestPasswordRecoveryActions.request,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners();
    const resp = await api.user.forgotPassword(action.payload);
    if (resp.ok) {
      listenerApi.dispatch(requestPasswordRecoveryActions.success());
    } else {
      listenerApi.dispatch(requestPasswordRecoveryActions.failure());
    }
  },
});

startListening({
  actionCreator: changePasswordActions.request,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners();
    const resp = await api.user.changePassword(action.payload.token, action.payload.password);
    if (resp.ok) {
      listenerApi.dispatch(changePasswordActions.success());
      message.success('Your password was successfully changed');
      window.location.assign('/auth');
    } else {
      listenerApi.dispatch(changePasswordActions.failure());
    }
  },
});
